(function() {
  var reportToggle = document.getElementById('report-issue-toggle');
  var reportWrap = document.getElementById('report-issue-form-wrap');
  var reportUrlField = document.getElementById('report-page-url');
  if (reportUrlField) reportUrlField.value = window.location.href;
  var claimUrlField = document.getElementById('claim-page-url');
  if (claimUrlField) claimUrlField.value = window.location.href;
  var claimToggle = document.getElementById('claim-toggle');
  var claimWrap = document.getElementById('claim-form-wrap');
  if (claimToggle && claimWrap) {
    claimToggle.addEventListener('click', function() {
      claimWrap.style.display = claimWrap.style.display === 'none' ? 'block' : 'none';
    });
  }
  if (reportToggle && reportWrap) {
    reportToggle.addEventListener('click', function() {
      reportWrap.style.display = reportWrap.style.display === 'none' ? 'block' : 'none';
    });
  }
})();
(function() {
  var configNode = document.querySelector('[data-minty-brand-runtime]');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var handle = config.handle;
  var brandName = config.name;
  var CHAR_THRESHOLD = 6;
  var SCROLL_THRESHOLD = 5;
  var THUMB_SIZE = 120;
  function makeRow(items, renderFn, threshold) {
    var t = (threshold !== undefined) ? threshold : SCROLL_THRESHOLD;
    var useScroll = items.length > t;
    var cls = useScroll ? 'mt-scroll-row' : 'mt-wrap-row';
    var html = '<div class="' + cls + '">';
    items.forEach(function(item) { html += renderFn(item); });
    html += '</div>';
    return html;
  }
  // Brand name lives in the H1 already, so repeating it in every section
  // header is four redundant repetitions on one page.
  function sectionHead(label, anchorId) {
    return '<h2 id="' + anchorId + '" style="margin-top:32px;margin-bottom:12px;font-size:1.1em;">' + label + '</h2>';
  }
  window.addEventListener('load', function() {
    var p = document.getElementById('mt-desc');
    var btn = document.getElementById('mt-desc-btn');
    if (p && btn && p.scrollHeight <= p.clientHeight + 2) { btn.style.display = 'none'; }
  });
  function dayIndex(name) {
    var names = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    return names.indexOf(name);
  }
  function apptSortKey(a) {
    var recurring = a.recurrence && a.recurrence !== 'None';
    if (recurring && a.days && a.days.length) {
      var idx = a.days.map(dayIndex).filter(function(i) { return i !== -1; });
      return idx.length ? Math.min.apply(null, idx) : 7;
    }
    if (a.date_time) { return new Date(a.date_time).getDay(); }
    return 7;
  }
  function sortAppearances(list) {
    return list.slice().sort(function(x, y) {
      var xr = x.recurrence && x.recurrence !== 'None';
      var yr = y.recurrence && y.recurrence !== 'None';
      if (!xr && !yr) {
        var xt = Date.parse(x.date_time), yt = Date.parse(y.date_time);
        if (isFinite(xt) && isFinite(yt) && xt !== yt) return xt - yt;
      }
      if (!!xr !== !!yr) return xr ? 1 : -1;
      var d = apptSortKey(x) - apptSortKey(y);
      if (d !== 0) return d;
      return (x.start_time || '99:99').localeCompare(y.start_time || '99:99');
    });
  }
  var PAST_GRACE_MS = 12 * 60 * 60 * 1000; // 12 hours after a gig ends, it moves to Past Appearances
  // Single source of truth for "when did/does this appearance end", in real
  // milliseconds. Recurring residencies end when residency_end_date passes;
  // one-offs end at date_time + duration (end_date_time, computed server-side).
  function appearanceEndTimestamp(a) {
    var recurring = a.recurrence && a.recurrence !== 'None';
    if (recurring) {
      return a.residency_end_date ? new Date(a.residency_end_date).getTime() : null;
    }
    var endIso = a.end_date_time || a.date_time;
    return endIso ? new Date(endIso).getTime() : null;
  }
  function isPastAppearance(a, nowMs) {
    var endTs = appearanceEndTimestamp(a);
    if (endTs == null) return false; // no end info on record — treat as still active
    return (endTs + PAST_GRACE_MS) < nowMs;
  }
  function fmtTime(t) {
    if (!t) return '';
    var m = String(t).trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return t;
    var h = parseInt(m[1], 10), min = m[2];
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + ':' + min + ' ' + ap;
  }
  function endTime(start, hours) {
    var m = String(start || '').trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!m || hours == null) return '';
    var total = parseInt(m[1], 10) * 60 + parseInt(m[2], 10) + Math.round(hours * 60);
    total = ((total % 1440) + 1440) % 1440;
    var h = Math.floor(total / 60), min = ('0' + (total % 60)).slice(-2);
    return fmtTime(h + ':' + min);
  }
  // Raw 24h HH:MM version of endTime(), for Schema.org Schedule.startTime/
  // endTime — those want ISO time-of-day, not the 12-hour display string.
  function endTime24(start, hours) {
    var m = String(start || '').trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!m || hours == null) return '';
    var total = parseInt(m[1], 10) * 60 + parseInt(m[2], 10) + Math.round(hours * 60);
    total = ((total % 1440) + 1440) % 1440;
    var h = Math.floor(total / 60), min = ('0' + (total % 60)).slice(-2);
    return ('0' + h).slice(-2) + ':' + min;
  }
  // Structured data (Schema.org JSON-LD): Event + Schedule for whatever's
  // actually rendered in the active Events section. Note this covers
  // AI-search/knowledge-graph visibility, not Google's visual Events
  // carousel — that carousel requires each event to have its own unique
  // URL per Google's own guidelines, which this page (many events, one
  // URL) doesn't provide. Building that would mean giving each Appearance
  // its own page, a bigger separate decision.
  function buildEventJsonLd(appts) {
    if (!appts || appts.length === 0) return;
    var events = appts.map(function(a) {
      if (!a.place_name) return null; // no location data — not enough for a valid Event
      var addr = { '@type': 'PostalAddress', 'addressCountry': 'US' };
      if (a.place_street_address) addr.streetAddress = a.place_street_address;
      if (a.place_city) addr.addressLocality = a.place_city;
      if (a.place_state) addr.addressRegion = a.place_state;
      if (a.place_zip_code) addr.postalCode = a.place_zip_code;
      var evt = {
        '@type': 'Event',
        'name': a.title || (brandName + ' at ' + a.place_name),
        'eventAttendanceMode': 'https://schema.org/OfflineEventAttendanceMode',
        'eventStatus': 'https://schema.org/EventScheduled',
        'location': { '@type': 'Place', 'name': a.place_name, 'address': addr },
        'performer': { '@type': 'Organization', 'name': a.performer_name || brandName },
        'organizer': { '@type': 'Organization', 'name': brandName, 'url': window.location.href }
      };
      if (a.description) evt.description = a.description;
      var recurring = a.recurrence && a.recurrence !== 'None';
      if (recurring && a.days && a.days.length) {
        var sched = {
          '@type': 'Schedule',
          'byDay': a.days.map(function(d) { return 'https://schema.org/' + d; }),
          'repeatFrequency': (a.recurrence === 'Monthly' ? 'P1M' : 'P1W')
        };
        if (a.start_time) sched.startTime = a.start_time;
        var et24 = endTime24(a.start_time, a.duration_hours);
        if (et24) sched.endTime = et24;
        if (a.residency_start_date) sched.startDate = a.residency_start_date;
        if (a.timezone) sched.scheduleTimezone = a.timezone;
        evt.eventSchedule = sched;
      } else if (a.date_time) {
        evt.startDate = a.date_time;
      }
      return evt;
    }).filter(Boolean);
    if (events.length === 0) return;
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(events.length === 1 ? events[0] : events);
    document.head.appendChild(script);
  }
  function dayCode(name) {
    var m = { Sunday:'SU', Monday:'MO', Tuesday:'TU', Wednesday:'WE', Thursday:'TH', Friday:'FR', Saturday:'SA' };
    return m[name] || '';
  }
  // Event Type icons. Scanning a list of cards is much faster with a glyph
  // than with words alone. Unmapped types simply render no icon.
  var EVENT_ICONS = {
    'karaoke': '\uD83C\uDFA4', 'live music': '\uD83C\uDFB8', 'live band': '\uD83C\uDFB8',
    'live band karaoke': '\uD83C\uDFB8', 'dj': '\uD83C\uDFA7', 'dj night': '\uD83C\uDFA7',
    'trivia': '\uD83E\uDDE9', 'comedy': '\uD83C\uDFAD', 'open mic': '\uD83C\uDF99',
    'bingo': '\uD83C\uDFB1', 'pool tournament': '\uD83C\uDFB1', 'food': '\uD83C\uDF54',
    'food truck': '\uD83D\uDE9A', 'happy hour': '\uD83C\uDF7A', 'drink specials': '\uD83C\uDF7A',
    'line dancing': '\uD83E\uDD20', 'special': '\u2B50'
  };
  function eventIcons(types) {
    if (!types || !types.length) return '';
    var seen = {}, out = [];
    types.forEach(function(t) {
      var ic = EVENT_ICONS[String(t).toLowerCase().trim()];
      if (ic && !seen[ic]) { seen[ic] = true; out.push(ic); }
    });
    return out.length ? out.join(' ') + ' ' : '';
  }
  // Next real occurrence, so cards can say "Tonight" instead of only "Mondays".
  function nextOccurrenceDate(a) {
    var recurring = a.recurrence && a.recurrence !== 'None';
    if (recurring && a.days && a.days.length) {
      var best = null;
      a.days.forEach(function(dn) {
        var d = nextDateForDay(dn);
        var tm = String(a.start_time || '').trim().match(/^(\d{1,2}):(\d{2})$/);
        if (tm) d.setHours(parseInt(tm[1], 10), parseInt(tm[2], 10), 0, 0);
        if (d < new Date()) d.setDate(d.getDate() + 7);
        if (!best || d < best) best = d;
      });
      return best;
    }
    if (a.date_time) {
      var one = new Date(a.date_time);
      return isNaN(one) ? null : one;
    }
    return null;
  }
  function relativeLabel(when) {
    if (!when) return '';
    var now = new Date();
    var ms = when - now;
    if (ms < 0) return '';
    var hrs = ms / 3600000;
    if (hrs < 1) return 'Starting soon';
    if (hrs < 7) return 'In ' + Math.max(1, Math.round(hrs)) + ' hours';
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var evDay = new Date(when.getFullYear(), when.getMonth(), when.getDate());
    var diff = Math.round((evDay - today) / 86400000);
    if (diff === 0) return 'Tonight';
    if (diff === 1) return 'Tomorrow';
    return '';
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function isApplePlatform() {
    return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent) && !window.MSStream;
  }
  function directionsUrl(address) {
    if (!address) return '';
    var q = encodeURIComponent(address);
    return isApplePlatform()
      ? 'https://maps.apple.com/?q=' + q
      : 'https://www.google.com/maps/search/?api=1&query=' + q;
  }
  function gcalStamp(d) {
    return d.getFullYear() + pad2(d.getMonth() + 1) + pad2(d.getDate()) + 'T' + pad2(d.getHours()) + pad2(d.getMinutes()) + '00';
  }
  function gcalUtcStamp(d) {
    return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  }
  function nextDateForDay(dayName) {
    var names = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var target = names.indexOf(dayName);
    var d = new Date();
    if (target === -1) return d;
    var diff = (target - d.getDay() + 7) % 7;
    d.setDate(d.getDate() + diff);
    return d;
  }
  function buildCalendarUrl(a) {
    var recurring = a.recurrence && a.recurrence !== 'None';
    var start;
    var durHours = Number(a.duration_hours);
    var calendarTime = String(a.start_time || '').trim().match(/^(\d{1,2}):(\d{2})$/);
    if (recurring && (!calendarTime || Number(calendarTime[1]) > 23 || Number(calendarTime[2]) > 59)) return '';
    if (!(!recurring && a.end_date_time) && !(isFinite(durHours) && durHours > 0)) return '';
    if (recurring && a.days && a.days.length) {
      start = nextDateForDay(a.days[0]);
      var tm = String(a.start_time || '').trim().match(/^(\d{1,2}):(\d{2})$/);
      if (tm) start.setHours(parseInt(tm[1], 10), parseInt(tm[2], 10), 0, 0);
    } else if (a.date_time) {
      start = new Date(a.date_time);
    } else {
      return '';
    }
    var end = (!recurring && a.end_date_time) ? new Date(a.end_date_time) : new Date(start.getTime() + durHours * 3600000);
    var dateRange = (!recurring && a.date_time)
      ? (gcalUtcStamp(start) + '/' + gcalUtcStamp(end))
      : (gcalStamp(start) + '/' + gcalStamp(end));
    var params = [
      'action=TEMPLATE',
      'text=' + encodeURIComponent(a.title || 'Event'),
      'dates=' + dateRange,
      'details=' + encodeURIComponent(a.description || ''),
      'location=' + encodeURIComponent(a.place_name || '')
    ];
    if (recurring && a.days && a.days.length) {
      var byday = a.days.map(dayCode).filter(Boolean).join(',');
      if (byday) params.push('recur=RRULE:FREQ=WEEKLY;BYDAY=' + byday);
    }
    if (a.timezone) params.push('ctz=' + encodeURIComponent(a.timezone));
    return 'https://calendar.google.com/calendar/render?' + params.join('&');
  }
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.mt-share-btn');
    if (!btn) return;
    var shareData = {
      title: btn.getAttribute('data-share-title') || document.title,
      text: btn.getAttribute('data-share-text') || '',
      url: btn.getAttribute('data-share-url') || window.location.href
    };
    if (navigator.share) {
      navigator.share(shareData).catch(function() {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(shareData.url).then(function() {
        var original = btn.textContent;
        btn.textContent = 'Copied!';
        setTimeout(function() { btn.textContent = original; }, 1500);
      });
    }
  });
  document.addEventListener('click', function(e) {
    var venmoLink = e.target.closest('.mt-venmo-link');
    if (!venmoLink) return;
    e.preventDefault();
    var appUrl = venmoLink.getAttribute('data-app-url');
    var webUrl = venmoLink.getAttribute('data-web-url');
    var didLeave = false;
    var markLeft = function() { didLeave = true; };
    document.addEventListener('visibilitychange', markLeft);
    window.addEventListener('blur', markLeft);
    window.addEventListener('pagehide', markLeft);
    window.location.href = appUrl;
    setTimeout(function() {
      document.removeEventListener('visibilitychange', markLeft);
      window.removeEventListener('blur', markLeft);
      window.removeEventListener('pagehide', markLeft);
      if (!didLeave) {
        window.location.href = webUrl;
      }
    }, 2500);
  });
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.mt-copy-btn');
    if (!btn) return;
    var text = btn.getAttribute('data-copy');
    var original = btn.textContent;
    var done = function() {
      btn.textContent = 'Copied!';
      setTimeout(function() { btn.textContent = original; }, 1500);
    };
    var fallback = function() {
      var t = document.createElement('textarea');
      t.value = text; t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(t);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function() { fallback(); done(); });
    } else { fallback(); done(); }
  });
  fetch(config.indexUrl)
    .then(function(r) { return r.json(); })
    .then(function(index) {
      var entry = null;
      var keys = Object.keys(index);
      for (var i = 0; i < keys.length; i++) {
        if (index[keys[i]].handle === handle) { entry = index[keys[i]]; break; }
      }
      if (!entry) return;
      var venueOperatorLabel = document.querySelector('.mt-brand-type-label[data-brand-type="Venue Operator"]');
      if (venueOperatorLabel && entry.places && entry.places.length === 1 && entry.places[0].venue_type && entry.places[0].venue_type.length) {
        venueOperatorLabel.textContent = entry.places[0].venue_type.join(' · ');
      }
      // Gather every Event relevant to this Brand's page: Events the Brand
      // itself is the performer/host for (entry.appearances — this now
      // includes venue-run Specials attributed via the Place rollup in
      // build-brand-index.js), plus Events other Brands are running at any
      // Place(s) this Brand owns. These used to render as two separate
      // sections ("Appearances" and "Events at Our Locations"), which reads
      // as if the venue's own schedule ends after the first section — the
      // split reflects an internal ownership-vs-performance distinction that
      // doesn't matter to someone scrolling the page. Combined here into one
      // correctly-ordered feed instead.
function mergeDirectoryEvents(events, nameKey, handleKey) {
  var byHandle = Object.create(null);
  var merged = [];
  events.forEach(function(source) {
    var event = source.handle && byHandle[source.handle];
    if (!event) {
      event = Object.assign({}, source, { directory_hosts: [] });
      merged.push(event);
      if (source.handle) byHandle[source.handle] = event;
    }
    if (source[handleKey] && !event.directory_hosts.some(function(host) { return host.handle === source[handleKey]; })) {
      event.directory_hosts.push({ name: source[nameKey], handle: source[handleKey] });
    }
  });
  return merged;
}
function directoryHostLinks(hosts) {
  return hosts.map(function(host) {
    var name = String(host.name || '').replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
    return '<a href="/pages/brand/' + encodeURIComponent(host.handle) + '" style="color:#1a7f4f;font-weight:600;text-decoration:underline;">' + name + '</a>';
  }).join(' and ');
}

      var allEvents = (entry.appearances || []).slice();
      if (entry.places && entry.places.length > 0) {
        var ownedHandles = entry.places.map(function(pl) { return pl.handle; });
        Object.keys(index).forEach(function(bid) {
          var otherBrand = index[bid];
          if (otherBrand === entry) return; // this Brand's own Events are already in allEvents above — walking them in again here would duplicate them and label them as a guest performer at itself.
          (otherBrand.appearances || []).forEach(function(a) {
            if (ownedHandles.indexOf(a.place_handle) === -1) return;
            allEvents.push(Object.assign({}, a, { performer_name: otherBrand.name, performer_handle: otherBrand.handle }));
          });
        });
      }
      allEvents = mergeDirectoryEvents(allEvents, 'performer_name', 'performer_handle');
      // Serving: every city this Brand actually appears in. A credential,
      // derived from data rather than typed by hand.
      var servingEl = document.getElementById('brand-serving');
      if (servingEl && servingEl.getAttribute('data-explicit') !== 'true') {
        var cityList = [];
        allEvents.forEach(function(a) {
          if (a.place_city && cityList.indexOf(a.place_city) === -1) cityList.push(a.place_city);
        });
        (entry.places || []).forEach(function(pl) {
          if (pl.city && cityList.indexOf(pl.city) === -1) cityList.push(pl.city);
        });
        if (cityList.length) {
          servingEl.innerHTML = '<span style="font-size:11px;color:#999;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;">Serving</span> '
            + '<span style="font-size:13px;color:#444;">' + cityList.join(' &middot; ') + '</span>';
        }
      }
      var stats = [
        { count: entry.char_count, label: 'character', anchor: '#section-characters' },
        { count: entry.product_count, label: 'product', anchor: '#section-products' },
        { count: entry.collection_count, label: 'design', anchor: '#section-collections' },
        { count: entry.post_count, label: 'post', anchor: '#section-posts' },
        { count: entry.place_count, label: 'location', anchor: '#section-places' },
        { count: allEvents.length, label: 'event', anchor: '#section-appearances' }
      ];
      var badgeHtml = '<div style="display:flex;gap:8px;flex-wrap:wrap;">';
      var hasBadge = false;
      // A pill reading "1 event" makes a page look empty rather than
      // established. Below two, say nothing.
      stats.forEach(function(s) {
        if (s.count > 1) {
          hasBadge = true;
          badgeHtml += '<a href="' + s.anchor + '" class="mt-badge-link">'
            + s.count + ' ' + s.label + (s.count !== 1 ? 's' : '') + '</a>';
        }
      });
      badgeHtml += '</div>';
      if (hasBadge) document.getElementById('brand-stats').innerHTML = badgeHtml;
      function renderAppearanceCard(a, isPastCard) {
        var recurring = a.recurrence && a.recurrence !== 'None';
        var when = '';
        if (recurring) {
          when = (a.days && a.days.length)
            ? a.days.map(function(d) { return d + 's'; }).join(', ')
            : a.recurrence;
        } else {
          // Prefer the server-derived, venue-local display string over
          // re-parsing date_time client-side (which would use the site
          // visitor's own browser timezone instead of the venue's).
          when = a.date_display || (a.date_time ? new Date(a.date_time).toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' }) : '');
        }
        var st = fmtTime(a.start_time);
        var et = endTime(a.start_time, a.duration_hours);
        var timeStr = st ? (st + (et ? '–' + et : '')) : '';
        var line = [when, timeStr].filter(Boolean).join(' · ');
        var relLabel = isPastCard ? '' : relativeLabel(nextOccurrenceDate(a));
        var relBadge = relLabel
          ? '<span style="display:inline-block;margin-left:8px;font-size:10px;font-weight:700;letter-spacing:0.05em;text-transform:uppercase;color:#fff;background:#1a7f4f;border-radius:20px;padding:2px 8px;vertical-align:1px;">' + relLabel + '</span>'
          : '';
        var calUrl = buildCalendarUrl(a);
        var eventHandle = a.handle || null;
        var shareUrl = eventHandle ? (window.location.origin + '/pages/events/' + eventHandle) : (window.location.origin + '/pages/place/' + a.place_handle);
        var addrLine = [a.place_street_address, [a.place_city, a.place_state].filter(Boolean).join(', ') + (a.place_zip_code ? ' ' + a.place_zip_code : '')].filter(Boolean).join(', ');
        var phoneDigits = a.place_phone_tel ? a.place_phone_tel.replace('+1', '') : '';
        var titleColor = isPastCard ? '#888' : '#1a7f4f';
        var cardStyle = 'flex-direction:column;align-items:stretch;gap:2px;padding:8px 14px 10px;' + (isPastCard ? 'opacity:0.65;' : '');
        return '<div class="mt-place-card" style="' + cardStyle + '">'
          + (line ? '<p style="margin:0;font-size:15px;font-weight:700;color:' + titleColor + ';"><svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" style="vertical-align:-2px;margin-right:4px;"><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"/></svg>' + line + relBadge + '</p>' : '')
          + (a.title ? '<p style="margin:0;font-size:14px;font-weight:600;color:#111;">' + eventIcons(a.event_types) + (eventHandle ? '<a href="/pages/events/' + eventHandle + '" style="font-size:inherit;font-weight:inherit;color:#1a7f4f;text-decoration:underline;text-underline-offset:3px;">' + a.title + '</a>' : a.title) + '</p>' : '')
          + (a.place_name ? '<a href="/pages/place/' + a.place_handle + '" style="margin:0;font-size:12px;color:#1a7f4f;font-weight:600;text-decoration:underline;">' + a.place_name + '</a>' : '')
          + (addrLine ? '<p style="margin:0;font-size:12px;color:#888;">' + addrLine + (phoneDigits ? ' &middot; Venue: <a href="tel:+1' + phoneDigits + '" style="color:#1a7f4f;font-weight:600;text-decoration:underline;">' + a.place_phone + '</a>' : '') + '</p>' : '')
          + ((a.description || a.directory_hosts.length) ? '<p style="margin:0 0 4px;font-size:12px;color:#666;line-height:1.4;">'
              + (a.description ? a.description : '')
              + (a.directory_hosts.length ? (a.description ? ' ' : '') + 'by ' + directoryHostLinks(a.directory_hosts) : '')
              + '</p>' : '')
          + (isPastCard ? '' :
            '<div style="display:flex;gap:8px;flex-wrap:wrap;">'
            + (calUrl ? '<a href="' + calUrl + '" target="_blank" rel="noopener" style="display:inline-block;font-size:12px;font-weight:600;color:#1a7f4f;border:1px solid #1a7f4f;border-radius:6px;padding:5px 12px;text-decoration:none;">+ Add to Google Calendar</a>' : '')
            + '<button type="button" class="mt-share-btn" data-share-title="' + (a.title || '').replace(/"/g, '&quot;') + '" data-share-text="' + (a.description || '').replace(/"/g, '&quot;') + '" data-share-url="' + shareUrl + '" style="font-size:12px;font-weight:600;color:#1a7f4f;border:1px solid #1a7f4f;border-radius:6px;padding:5px 12px;background:transparent;cursor:pointer;">Share</button>'
            + '</div>')
          + '</div>';
      }
      if (allEvents.length > 0) {
        var nowMs = Date.now();
        var activeAppts = [];
        var pastAppts = [];
        allEvents.forEach(function(a) {
          if (isPastAppearance(a, nowMs)) { pastAppts.push(a); } else { activeAppts.push(a); }
        });
        activeAppts = sortAppearances(activeAppts);
        buildEventJsonLd(activeAppts);
        pastAppts = pastAppts.slice().sort(function(x, y) {
          return (appearanceEndTimestamp(y) || 0) - (appearanceEndTimestamp(x) || 0); // most recently ended first
        });
        // Distinct Event Types actually present on this Brand's page, in
        // first-seen order — the filter only ever shows options that exist
        // here, so it grows on its own as new Event Types show up (a KJ, a
        // food truck) and never displays options with nothing behind them.
        var eventTypeOptions = [];
        activeAppts.concat(pastAppts).forEach(function(a) {
          (a.event_types || []).forEach(function(t) {
            if (eventTypeOptions.indexOf(t) === -1) eventTypeOptions.push(t);
          });
        });
        // Empty selectedEventTypes means "show everything" (the default,
        // equivalent to "All"). Non-empty means only Events whose own
        // event_types list intersects the selection are shown — applied to
        // both the active and past lists from the same control, since a
        // visitor filtering by "DJ" presumably wants that whether they're
        // looking at what's upcoming or what already happened.
        var selectedEventTypes = [];
        function eventMatchesFilter(a) {
          if (selectedEventTypes.length === 0) return true;
          return (a.event_types || []).some(function(t) { return selectedEventTypes.indexOf(t) !== -1; });
        }
        function renderEventFilterChips() {
          var allActive = selectedEventTypes.length === 0;
          var html = '<button type="button" class="mt-event-filter-chip" data-type="" style="font-size:11px;font-weight:600;border:none;border-radius:20px;padding:4px 12px;cursor:pointer;background:'
            + (allActive ? '#1a7f4f' : '#f4f4f4') + ';color:' + (allActive ? '#fff' : '#555') + ';">All</button>';
          eventTypeOptions.forEach(function(t) {
            var isOn = allActive || selectedEventTypes.indexOf(t) !== -1;
            html += '<button type="button" class="mt-event-filter-chip" data-type="' + t.replace(/"/g, '&quot;') + '" style="font-size:11px;font-weight:600;border:none;border-radius:20px;padding:4px 12px;cursor:pointer;background:'
              + (isOn ? '#1a7f4f' : '#f4f4f4') + ';color:' + (isOn ? '#fff' : '#555') + ';">' + t + '</button>';
          });
          return html;
        }
        function renderEventSections() {
          var activeFiltered = activeAppts.filter(eventMatchesFilter);
          var pastFiltered = pastAppts.filter(eventMatchesFilter);
          if (activeAppts.length > 0) {
            var headerRow = '<div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;margin-top:32px;margin-bottom:12px;">'
              + '<h2 id="section-appearances" style="margin:0;font-size:1.1em;">Events</h2>';
            if (eventTypeOptions.length > 1) {
              headerRow += '<div class="mt-event-filter" style="display:flex;gap:6px;flex-wrap:wrap;">' + renderEventFilterChips() + '</div>';
            }
            headerRow += '</div>';
            var appHtml = headerRow + '<div style="display:flex;flex-direction:column;gap:12px;">';
            if (activeFiltered.length > 0) {
              activeFiltered.forEach(function(a) { appHtml += renderAppearanceCard(a, false); });
            } else {
              appHtml += '<p style="font-size:13px;color:#888;">No upcoming events match this filter.</p>';
            }
            appHtml += '</div>';
            document.getElementById('brand-appearances').innerHTML = appHtml;
          }
          if (pastAppts.length > 0) {
            var pastHtml = sectionHead('Past Events', 'section-past-appearances') + '<div style="display:flex;flex-direction:column;gap:12px;">';
            if (pastFiltered.length > 0) {
              pastFiltered.forEach(function(a) { pastHtml += renderAppearanceCard(a, true); });
            } else {
              pastHtml += '<p style="font-size:13px;color:#888;">No past events match this filter.</p>';
            }
            pastHtml += '</div>';
            document.getElementById('brand-appearances-past').innerHTML = pastHtml;
          }
        }
        document.addEventListener('click', function(e) {
          var chip = e.target.closest('.mt-event-filter-chip');
          if (!chip) return;
          var type = chip.getAttribute('data-type');
          if (type === '') {
            selectedEventTypes = [];
          } else {
            var idx = selectedEventTypes.indexOf(type);
            if (idx === -1) { selectedEventTypes.push(type); } else { selectedEventTypes.splice(idx, 1); }
          }
          renderEventSections();
        });
        renderEventSections();
      }
      if (entry.posts && entry.posts.length > 0) {
        var postHtml = sectionHead('Blog Posts', 'section-posts') + '<div style="display:flex;flex-direction:column;gap:12px;">';
        entry.posts.forEach(function(p) {
          var thumb = p.image ? '<img src="' + p.image + '" style="width:80px;height:80px;object-fit:cover;border-radius:6px;flex-shrink:0;" alt="">' : '';
          var excerpt = p.excerpt
            ? (p.excerpt.replace(/<[^>]+>/g, '').substring(0, 150) + (p.excerpt.length > 150 ? '...' : ''))
            : (p.content ? p.content.replace(/<[^>]+>/g, '').substring(0, 150) + '...' : '');
          
          postHtml += '<a href="' + p.url + '" class="mt-post-card" style="display:flex;gap:14px;align-items:flex-start;padding:14px 16px;background:transparent;border:1px solid #ddd;border-radius:8px;text-decoration:none;max-width:600px;">'
            + thumb
            + '<div style="flex:1 1 auto;min-width:0;">'
            + '<p style="margin:0 0 4px;font-size:14px;font-weight:600;color:inherit;" class="mt-post-title">' + p.title + '</p>'
            + (excerpt ? '<p style="margin:0 0 8px;font-size:12px;color:#666;line-height:1.4;">' + excerpt + '</p>' : '')
            + '<span style="font-size:12px;color:#888;">Read more &rarr;</span>'
            + '</div>'
            + '</a>';
        });
        postHtml += '</div>';
        document.getElementById('brand-posts').innerHTML = postHtml;
      }
      if (entry.collections && entry.collections.length > 0) {
        var colRow = makeRow(entry.collections, function(col) {
          var count = col.product_count || 0;
          var countHtml = count > 0
            ? '<p class="mt-design-count">' + count + ' Product' + (count !== 1 ? 's' : '') + '</p>'
            : '';
          var imgHtml = col.image
            ? '<img src="' + col.image + '" alt="' + col.title + '" style="width:100%;height:100%;object-fit:cover;display:block;">'
            : '<div style="width:100%;height:100%;background:#f0f0f0;"></div>';
          return '<a href="' + col.url + '" class="mt-design-link" style="flex:0 0 ' + THUMB_SIZE + 'px;width:' + THUMB_SIZE + 'px;">'
            + '<div class="mt-design-stack">'
            + '<div class="mt-design-thumb-wrap" style="width:' + THUMB_SIZE + 'px;height:' + THUMB_SIZE + 'px;">'
            + '<span class="mt-design-pill">Shop</span>'
            + imgHtml
            + '<span class="mt-design-overlay">View Collection &rarr;</span>'
            + '</div>'
            + '</div>'
            + '<p style="text-align:center;font-size:11px;font-weight:600;margin:6px 0 0;line-height:1.3;">' + col.title + '</p>'
            + countHtml
            + '</a>';
        });
        document.getElementById('brand-collections').innerHTML =
          '<h2 id="section-collections" style="margin-top:32px;margin-bottom:12px;font-size:1.1em;">Shop Designs</h2>'
          + colRow;
      }
      if (entry.characters && entry.characters.length > 0) {
        var charRow = makeRow(entry.characters, function(c) {
          var html = '<a href="/pages/brand-characters/' + c.handle + '" class="mt-char-link" style="text-decoration:none;color:inherit;flex:0 0 100px;width:100px;text-align:center;">'
            + '<div class="mt-char-card">';
          if (c.image) {
            html += '<img src="' + c.image + '" alt="' + c.name + '" style="width:100px;height:100px;object-fit:cover;border-radius:6px;display:block;">';
          } else {
            html += '<div style="width:100px;height:100px;background:#f0f0f0;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:30px;">&#128049;</div>';
          }
          html += '<p class="mt-char-name" style="font-weight:bold;margin:4px 0 0;font-size:12px;">' + c.name + '</p>'
            + '<p class="mt-char-cta">View &rarr;</p>'
            + '</div></a>';
          return html;
        }, CHAR_THRESHOLD);
        document.getElementById('brand-characters').innerHTML =
          sectionHead('Characters', 'section-characters') + charRow;
      }
      if (entry.products && entry.products.length > 0) {
        var prodRow = makeRow(entry.products, function(p) {
          var html = '<a href="' + p.url + '" style="text-decoration:none;color:inherit;flex:0 0 ' + THUMB_SIZE + 'px;width:' + THUMB_SIZE + 'px;">'
            + '<div class="mt-prod-card">';
          if (p.image) {
            html += '<img src="' + p.image + '" width="240" height="240" style="width:' + THUMB_SIZE + 'px;height:' + THUMB_SIZE + 'px;object-fit:cover;border-radius:4px;display:block;">';
          }
          html += '<p style="text-align:center;font-size:11px;margin-top:4px;line-height:1.3;">' + p.title + '</p>'
            + '</div></a>';
          return html;
        });
        var seeAll = '';
        if (entry.collections && entry.collections.length > 0 && entry.products.length > SCROLL_THRESHOLD) {
          seeAll = '<a href="' + entry.collections[0].url + '" class="mt-see-all">See all ' + entry.product_count + ' products &rarr;</a>';
        }
        document.getElementById('brand-products').innerHTML =
          sectionHead('Featured Gear', 'section-products') + prodRow + seeAll;
      }
      // Keep the physical location visibly connected to the Brand even when
      // there is only one venue. That relationship is part of the directory's
      // public value, not merely an internal data link.
      var soleVenueOperator = (entry.brand_type || []).indexOf('Venue Operator') !== -1
        && entry.places && entry.places.length === 1;
      if (entry.places && entry.places.length > 0) {
        var placeSectionTitle = entry.places.length === 1 ? 'Location' : 'Locations';
        var placeHtml = sectionHead(placeSectionTitle, 'section-places') + '<div style="display:flex;flex-direction:column;gap:12px;">';
        entry.places.forEach(function(pl) {
          var chips = (pl.venue_type || []).map(function(t) { return '<span class="mt-place-chip">' + t + '</span>'; }).join(' ');
          var amenChips = (pl.amenities || []).map(function(t) { return '<span class="mt-place-chip">' + t + '</span>'; }).join(' ');
          var addrLine1 = pl.street_address || '';
          var addrLine2 = [pl.city, pl.state].filter(Boolean).join(', ') + (pl.zip_code ? ' ' + pl.zip_code : '');
          var fullAddress = [addrLine1, [pl.city, pl.state, pl.zip_code].filter(Boolean).join(', ')].filter(Boolean).join(', ');
          var mapsHref = directionsUrl(fullAddress);
          var phoneDigits = pl.phone_tel ? pl.phone_tel.replace('+1', '') : '';
          placeHtml += '<div class="mt-place-card" style="flex-direction:column;align-items:stretch;gap:2px;padding:8px 14px 10px;background:#eaf3de;border-color:#d3e8c0;">'
            + '<a href="/pages/place/' + pl.handle + '" style="text-decoration:none;color:inherit;">'
            + '<p style="margin:0 0 6px;font-size:15px;font-weight:700;color:#111;"><svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" style="vertical-align:-2px;margin-right:4px;color:#1a7f4f;"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>' + pl.name + '</p>'
            + (addrLine1 ? '<p style="margin:0;font-size:13px;color:#444;">' + addrLine1 + '</p>' : '')
            + (addrLine2 ? '<p style="margin:0 0 6px;font-size:13px;color:#444;">' + addrLine2 + '</p>' : '')
            + '</a>'
            + '<div style="display:flex;align-items:center;flex-wrap:wrap;gap:8px;margin-bottom:6px;">'
            + (mapsHref ? '<a href="' + mapsHref + '" target="_blank" rel="noopener" style="font-size:12px;color:#1a7f4f;text-decoration:none;font-weight:600;">Get directions &rarr;</a>' : '')
            + (phoneDigits ? '<a href="tel:+1' + phoneDigits + '" style="font-size:12px;color:#1a7f4f;text-decoration:none;font-weight:600;">' + pl.phone + '</a>' : '')
            + '</div>'
            + (amenChips ? '<div style="display:flex;gap:4px;flex-wrap:wrap;margin-top:6px;">' + amenChips + '</div>' : '')
            + '<div style="display:flex;align-items:center;flex-wrap:wrap;gap:8px;margin-top:8px;">'
            + (chips ? '<div style="display:flex;gap:4px;flex-wrap:wrap;">' + chips + '</div>' : '')
            + '<a href="/pages/place/' + pl.handle + '" style="margin-left:auto;font-size:12px;font-weight:600;color:#1a7f4f;text-decoration:none;">View location details &rarr;</a>'
            + '</div>'
            + '</div>';
        });
        placeHtml += '</div>';
        document.getElementById('brand-places').innerHTML = placeHtml;
      }
      window.dispatchEvent(new CustomEvent('minty:brand-content-ready', {detail:{handle:handle}}));
    }).catch(function() { window.mintyBrandContentUnavailable = true; });
})();
